import { useState } from "preact/hooks";
import { strings } from "../i18n/strings.es-AR.js";
import { phase, conversation, agentName } from "../state/store.js";
import { getEntry, startNew, closeSession } from "../hooks/useConversation.js";
import { AccountMenu } from "./AccountMenu.jsx";
import { ConfirmDialog } from "./ConfirmDialog.jsx";
import { Header, getAccountLabel } from "./Header.jsx";
import { Icon } from "./icons.jsx";

// Textos de la confirmación según lo elegido en el menú de la cuenta.
const CLOSE_CONFIRM = {
  switch: {
    title: strings.switchAccountConfirmTitle,
    body: strings.switchAccountConfirmBody,
    action: strings.switchAccountConfirmAction
  },
  logout: {
    title: strings.logoutConfirmTitle,
    body: strings.logoutConfirmBody,
    action: strings.logoutConfirmAction
  }
};
import { OfflineBanner } from "./OfflineBanner.jsx";
import { NotificationsBanner } from "./NotificationsBanner.jsx";
import { InstallBanner } from "./InstallBanner.jsx";
import { MessageList } from "./MessageList.jsx";
import { Composer } from "./Composer.jsx";

export function ChatScreen() {
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  // null | "switch" (otra cuenta) | "logout" (cerrar sesión): qué confirmar.
  const [confirmingClose, setConfirmingClose] = useState(null);
  const mode = getEntry().mode;
  const currentPhase = phase.value;
  const confirm = confirmingClose && CLOSE_CONFIRM[confirmingClose];

  // La app ocupa TODO el viewport, en mobile y en desktop. Cada pieza pinta su
  // fondo a todo el ancho y centra su contenido en `chat-col` (definida en
  // styles.css): ese es el único lugar donde vive el ancho máximo.
  return (
    <div class="flex h-full w-full flex-col">
      {mode !== "miflux" && <Header onOpenAccountMenu={() => setAccountMenuOpen(true)} />}
      <OfflineBanner />

      {conversation.value.handoffActive && (
        <div class="bg-flux-cyan px-4 py-2 text-xs font-medium text-flux-navy">
          <div class="chat-col text-center">
            {strings.agentBanner(agentName.value)} · {strings.handoffActive}
          </div>
        </div>
      )}
      <NotificationsBanner />
      <InstallBanner />

      {currentPhase === "error" ? (
        <div class="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
          <p class="text-sm text-white/80">{strings.errorStart}</p>
          <button
            type="button"
            class="rounded-full bg-flux-primary px-5 py-2 text-sm font-medium text-white"
            onClick={() => startNew()}
          >
            {strings.retry}
          </button>
        </div>
      ) : currentPhase === "closed" ? (
        <div class="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
          <span class="text-flux-cyan"><Icon name="circle-check" size={32} /></span>
          <p class="text-sm text-white/80">{strings.sessionClosed}</p>
          <button
            type="button"
            class="rounded-full bg-flux-primary px-5 py-2 text-sm font-medium text-white"
            onClick={() => startNew()}
          >
            {strings.startAgain}
          </button>
        </div>
      ) : (
        <>
          <MessageList />
          <Composer />
        </>
      )}

      {accountMenuOpen && (
        <AccountMenu
          accountLabel={getAccountLabel(conversation.value)}
          onCancel={() => setAccountMenuOpen(false)}
          onChoose={(action) => { setAccountMenuOpen(false); setConfirmingClose(action); }}
        />
      )}

      {/* Las dos salidas borran el hilo del dispositivo y no tienen deshacer.
          Con un agente atendiendo, además se corta el handoff: se avisa. */}
      {confirm && (
        <ConfirmDialog
          title={confirm.title}
          body={conversation.value.handoffActive
            ? `${confirm.body} ${strings.closeSessionHandoffWarning}`
            : confirm.body}
          confirmLabel={confirm.action}
          cancelLabel={strings.cancel}
          onCancel={() => setConfirmingClose(null)}
          onConfirm={() => {
            const restart = confirmingClose === "switch";
            setConfirmingClose(null);
            closeSession({ restart });
          }}
        />
      )}
    </div>
  );
}
